import { Component, HostListener, input, output } from '@angular/core';
import { CoreModule } from '../../core.module';

@Component({
    selector: 'tvcore-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss'],
    imports: [CoreModule]
})
export class DialogComponent {
	close = output();
	visible = input<boolean>(false);
	title = input.required();

	@HostListener('document:keydown.Escape', ['$event'])
	doClose(event?: any) {
		if (event && event instanceof PointerEvent) {
			if ((event as any).target.classList.contains('c-dialog--show')) {
				this.close.emit();
			}
		} else {
			this.close.emit();
		}
	}
}
